module.exports = __webpack_public_path__ + "media/images/trust-icon-validation-958bf0948a7016b6374d5d8d977a1532.svg";